import { cloneDeep } from "lodash-es";
import React, { useState } from "react";
import { Form } from "react-final-form";
import { Alert, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { CptCodeListPriceForm } from "./CptCodeListPriceForm";

export const EditCptCodeListPriceModal = ({ cptCodeListPrice, onEdit, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleEdit = async (values) => {
    const newValues = cloneDeep(values);
    setError(null);
    try {
      const res = await api.patch(`/admin/lab_cpt_code_list_prices/${cptCodeListPrice.id}`, {
        lab_cpt_code_list_price: snakifyKeys(newValues),
      });

      if (onEdit) {
        onEdit(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  const initialValues = {
    ...cptCodeListPrice,
    cptCodeId: cptCodeListPrice.cptCode.id,
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Cpt Code List Price</ModalHeader>

        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}

          <Form onSubmit={handleEdit} initialValues={initialValues}>
            {(props) => <CptCodeListPriceForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
